
<div :id="content.idHTML" class="row" :class="jel_getClassObject(content)">
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libPrenom"
    :rules="
      'required|min:' +
      rules.minPrenomNomLength +
      '|max:' +
      rules.maxPrenomNomLength +
      '|compteValidation:prenom'
    "
    class="col-xl-6"
    tag="div"
  >
    <b-form-group :label="content.libPrenom" label-for="prenom">
      <b-form-input
        id="prenom"
        v-model="prenom"
        v-capitalize
        v-remove-extra-spaces
        trim
        :name="content.inputNamePrenom ? content.inputNamePrenom : 'given-name'"
        class="mb-1"
        :maxLength="rules.maxPrenomNomLength"
        :state="getValidationState(validationContext)"
      />
      <ErreurValidation
        id="prenom-live-feedback"
        :message="validationContext.errors[0]"
        :variables="variablesARemplacer"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
  <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
  <ValidationProvider
    v-slot="validationContext"
    :name="content.libNom"
    :rules="
      'required|min:' +
      rules.minPrenomNomLength +
      '|max:' +
      rules.maxPrenomNomLength +
      '|compteValidation:nom'
    "
    class="col-xl-6"
    tag="div"
  >
    <b-form-group :label="content.libNom" label-for="nom">
      <b-form-input
        id="nom"
        v-model="nom"
        v-capitalize
        v-remove-extra-spaces
        :name="content.inputNameNom ? content.inputNameNom : 'family-name'"
        trim
        class="mb-1"
        :maxlength="rules.maxPrenomNomLength"
        :state="getValidationState(validationContext)"
      />
      <ErreurValidation
        id="nom-live-feedback"
        :message="validationContext.errors[0]"
        :classesCSS="$isMobile() ? 'pb-2' : ''"
        :variables="variablesARemplacer"
      ></ErreurValidation>
    </b-form-group>
  </ValidationProvider>
</div>
